import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import {productRoutes} from '@/views/product/ProductRoutes';
import Index from '@/views/Index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/major-tom'
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/Cart.vue'),
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('@/views/Checkout.vue'),
  },
    /*
  {
    path: '/',
    name: 'Home',
    component: Index,
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/components/ChoosePath.vue')
  },
  {
    path: '/mode/hifi',
    name: 'HiFiLanding',
    component: () => import('@/views/mode/HiFiLanding.vue')
  },
  {
    path: '/mode/studio',
    name: 'StudioLanding',
    component: () => import('@/views/mode/StudioLanding.vue')
  },
     */
    ...productRoutes

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;

